<template>
  <div
    id="manage-wrapper"
    class="greedy" >
    <div
      id="menu-column"
      class="SB-border right no-shrink"
      :class="{'announcement-space': showAnnouncement }" >
      <ConversationHeader
        :basic="true"
        :manage="true" />

      <div class="sections-wrapper flex column">

        <!-- <h3 class="section-title">Tools</h3> -->
        <!-- REMOVE when flow component is finished -->
        <!-- <router-link
          :to="{ name: 'FlowTest' }" >
          <span
            class="flex flex-align-center" >
            <span class="icon-wrapper AI mr-2" />
            <p>AI Assistant</p>
          </span>
        </router-link> -->

        <!-- CHANNELS -->
        <h3 class="section-title">Channels</h3>
        <router-link
          v-for="(channel, index) in channelsData"
          :key="`c-${index}`"
          :to="{ name: channel.routeName }" >
          <span
            class="flex flex-align-center" >
            <img
              v-if="channel.icons"
              :src="channel.icons.dark"
              style="height: 16px; width: 16px; margin-right: 8px;" >
            <p>{{ channel.label }}</p>
            <SBIcon
              v-if="channel.active"
              class="ml-2"
              :icon="SBIconList.DONE_CIRCLE"
              :color="SBColors.blackPrimary"
              :size="12" />
          </span>
        </router-link>

        <!-- INTEGRATIONS -->
        <h3 class="section-title">Integrations</h3>
        <router-link
          v-for="(integration, index) in integrationsData"
          :key="`i-${index}`"
          :to="{ name: integration.routeName }"
          exact-path >
          <span
            class="flex flex-align-center" >
            <img
              v-if="integration.icons"
              :src="integration.icons.dark"
              style="height: 16px; width: 16px; margin-right: 8px;" >
            <p>{{ integration.label }}</p>
            <SBIcon
              v-if="integration.active"
              class="ml-2"
              :icon="SBIconList.DONE_CIRCLE"
              :color="SBColors.blackPrimary"
              :size="12" />
          </span>
        </router-link>
        <router-link
          :to="{ name: 'DevelopersManage' }" >
          <span
            class="flex flex-align-center" >
            <span class="icon-wrapper API mr-2" />
            <p>Developers</p>
          </span>
        </router-link>

        <!-- SETTINGS -->
        <h3 class="section-title">Other</h3>
        <router-link
          :to="{ name: 'BlocklistSettings' }"
          exact-path >
          <span
            class="flex flex-align-center" >
            <SBIcon
              class="mr-2"
              :icon="SBIconList.BLOCKED"
              :color="SBColors.blackPrimary"
              :size="16" />
            <p>Blocked</p>
          </span>
        </router-link>
        <router-link
          :to="{ name: 'ConsentManagement' }"
          exact-path >
          <span
            class="flex flex-align-center" >
            <SBIcon
              class="mr-2"
              :icon="SBIconList.PROFILE_SHIELD"
              :color="SBColors.blackPrimary"
              :size="16" />
            <p>Consent management</p>
          </span>
        </router-link>
        <router-link
          :to="{ name: 'WorkingHours' }"
          exact-path >
          <span
            class="flex flex-align-center" >
            <SBIcon
              class="mr-2"
              :icon="SBIconList.WORKING_HOURS"
              :color="SBColors.blackPrimary"
              :size="16" />
            <p>Working hours</p>
          </span>
        </router-link>
      </div>
    </div>
    <div
      class="greedy content-wrapper flex"
      :class="{'announcement-space': showAnnouncement, 'full-width': isFullWidth, 'full-window': fullWindow}">
      <router-view
        :key="updateKey"
        class="content greedy" />
    </div>
  </div>
</template>

<script>
import ConversationHeader from '@/components/business/chat/partials/ConversationHeader';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'NumberManage',
  components: {
    SBIcon,
    ConversationHeader,
  },
  data() {
    return {
      SBIconList,
      SBColors,
      updateKey: 0,
      channelsToShow: [
        {
          code: 'whatsapp',
          routeName: 'WAManage',
        },
      ],
      integrationsToShow: [
        {
          code: 'FRONTPACHA',
          routeName: 'SBFManage',
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      integrationsRegistryData: 'organisation/integrationsRegistryData',
      channelsDataRegistry: 'organisation/channelsDataRegistry',
      organisationNumbers: 'organisation/organisationNumbers',
      currentOrganisation: 'organisation/currentOrganisation',
      numberIntegrationMap: 'organisation/numberIntegrationMap',
      showAnnouncement: 'system/showAnnouncement',
      fullWindow: 'system/fullWindow',
    }),
    business() {
      return this.currentOrganisation.businesses.find(b => b.id === this.$route.params.businessId);
    },
    channelsData() {
      const cData = [];
      this.channelsToShow.forEach((channel) => {
        const cReg = this.channelsDataRegistry.find(cdr => cdr.code === channel.code);
        if (cReg) {
          cData.push({
            ...channel,
            active: this.business[channel.code],
            label: cReg.name,
            icons: cReg.icons,
          });
        }
      });

      return cData;
    },
    isFullWidth() {
      return this.$route && this.$route.meta && this.$route.meta.fullWidth;
    },
    integrationsData() {
      const iData = [];
      this.integrationsToShow.forEach((integration) => {
        const iReg = this.integrationsRegistryData.find(ird => ird.code === integration.code);
        if (iReg) {
          iData.push({
            ...integration,
            label: iReg.name,
            active: this.business.id && iReg.organisation_specific_data && iReg.organisation_specific_data.business && iReg.organisation_specific_data.business[this.business.id] ? !!iReg.organisation_specific_data.business[this.business.id].length : false,  // this.numberIntegrationMap && this.numberIntegrationMap[this.business.id] ? this.numberIntegrationMap[this.business.id].includes(integration.code) : false,
            icons: iReg.icons,
          });
        }
      });

      return iData;
    },
  },
  watch: {
    business(newValue, oldValue) {
      if (newValue.id !== oldValue.id) {
        this.updateKey += 1;
      }
    },
  },
  methods: {
    ...mapActions({
      fetchIntegrationsRegistry: 'organisation/fetchIntegrationsRegistry',
    }),
  },
};
</script>

<style lang="scss" scoped>
.input-group .input-group-append .btn {
  box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.15);
}

.input-group .input-group-append .btn:hover,
.input-group .input-group-append .btn:active {
  border: solid 1px #cfd8dc;
  background-color: #f8fafb;
}
</style>

<style lang="scss" scoped>
#manage-wrapper {
  display: flex;
  min-width: 0;
  background-color: $white;

  .content-wrapper {
    overflow: auto;
    background-color: $white;
    padding: 0 40px 0;
    min-width: 0;

    &:not(.full-width) {
      max-width: 1260px;
    }

    .content {
      max-width: 100%;
    }

    &.full-window {
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 1039;
    }

    ::v-deep .channel-header {
      padding-top: 35px;
    }
  }
}

#menu-column {
  width: 339px;
  background-color: white;
  display: flex;
  flex-direction: column;
  box-shadow: 1px 0 $greyBorderSecondary;
  overflow: hidden;

  .sections-wrapper {
    overflow-y: auto;
  }

  /* Gives the initial height to the element so it doesn't overflow. */
  .basic-height {
    height: 10px;
  }

  .section-title {
    margin-top: 15px;
    margin-left: 10px;
    margin-bottom: 0px;
    font-size: 12px;
    font-weight: 500;
    color: $blackUltralight;
  }

  .icon-wrapper {
    background-size: 16px 16px;
    height: 16px;
    width: 16px;
  }

  a {
    margin: 2px 10px 0;
    padding: 10px 12px 10px 12px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 400;
    color: $blackPrimary;

    &:hover, &:active {
      text-decoration: none;
    }

    &:hover {
      background-color: #f7f8f8;
    }

    &.router-link-exact-active, &.router-link-active {
      background-color: #edf0f2;
    }
  }

  .section-title + a {
    margin-top: 7px;
  }
}
</style>
